import axios from '@/plugins/api.request'

/**
 * 上传文件
 * @param {*} config
 */
export const uploadFile = (config) => {
  let baseConfig = {
    method: 'post',
    url: 'v2api.php?s=Match.Upload.UploadFile',
  }
  Object.assign(baseConfig, config)
  return axios.request(baseConfig)
}

/**
 * 上传图片
 * @param {*} config
 */
export const uploadImage = (config) => {
  let baseConfig = {
    method: 'post',
    url: 'v2api.php?s=Match.Upload.UploadImg',
  }
  Object.assign(baseConfig, config)
  return axios.request(baseConfig)
}